function appConfig($mdThemingProvider, $mdDateLocaleProvider) {
    $mdThemingProvider.definePalette('kokoaPalette', {
        '50': 'e2f5f7',
        '100': 'b6e7ec',
        '200': '86d7e0',
        '300': '55c6d3',
        '400': '30bac9',
        '500': '0caec0',
        '600': '0aa7ba',
        '700': '089db2',
        '800': '0694aa',
        '900': '03849c',
        'A100': 'c7f5ff',
        'A200': '94ecff',
        'A400': '61e2ff',
        'A700': '47deff',
        'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
                                            // on this palette should be dark or light

        'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
            '200', '300', '400', 'A100'],
        'contrastLightColors': undefined    // could also specify this if default was 'dark'
    });

    $mdThemingProvider.definePalette('kokoaAccentPalette', {
        '50': 'e2f5f7',
        '100': 'b6e7ec',
        '200': '86d7e0',
        '300': '55c6d3',
        '400': '30bac9',
        '500': '0caec0',
        '600': '0aa7ba',
        '700': '089db2',
        '800': '0694aa',
        '900': '03849c',
        'A100': '268fc3',
        'A200': '0892bd',
        'A400': '33c7e8',
        'A700': '2b689c',
        'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
                                            // on this palette should be dark or light

        'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
            '200', '300', '400'],
        'contrastLightColors': undefined    // could also specify this if default was 'dark'
    });
    const white = $mdThemingProvider.extendPalette('grey', {
        'A100': 'ffffff',
        '50': 'ffffff',
        'contrastDefaultColor': 'dark'
    });

    // Register the new color palette map with the name <code>neonRed</code>
    $mdThemingProvider.definePalette('white', white);

    $mdThemingProvider.setDefaultTheme('kokoa');
    $mdThemingProvider.theme('kokoa')
        .primaryPalette('kokoaPalette')
        .accentPalette('kokoaAccentPalette')
        .backgroundPalette('white');


    $mdDateLocaleProvider.formatDate = function(date) {
        if (date) {
            let day = date.getDate();
            let monthIndex = date.getMonth();
            let year = date.getFullYear();
            return day + '.' + (monthIndex + 1) + '.' + year;
        } else {
            return '';
        }
    };
    $mdDateLocaleProvider.parseDate = function(dateString) {
        if (dateString) {
            var parts = dateString.split('.');
            var date = new Date(parts[2], parts[1] - 1, parts[0]);
            let day = date.getDate();
            let monthIndex = date.getMonth();
            let year = date.getFullYear();
            return new Date(year, monthIndex, day);
        } else {
            return new Date(NaN);
        }
    };
}


export default appConfig;



// WEBPACK FOOTER //
// ./src/app/app.config.js